import React from "react";
import { Typography } from "@mui/material";

const Shop = () => {
    return <Typography variant="h4">Shop!</Typography>;
};

export default Shop;
